import type { ReactNode } from 'react';

import { ListingViewSidebarHolder } from './ListingViewSidebar.styled';

type Props = {
  id?: string;
  children: ReactNode;
  maxWidth?: number;
  qaId?: string;
};

export function ListingViewSidebar({ id, children, maxWidth, qaId }: Props) {
  return (
    <ListingViewSidebarHolder
      id={id}
      data-qa-id={qaId}
      style={{ maxWidth }}
      $withFilters
    >
      {children}
    </ListingViewSidebarHolder>
  );
}
